export default __webpack_public_path__ + "static/ic_webinar_cer_9001-d16d6be173d56dd239762ac3a7be48f3.svg";